/**
 * Internal helper for the Forms services (not exported from the barrel).
 */
/** Return response.data or throw `message` when the envelope carries no data. */
export function unwrapFormsResponse(response, message) {
    if (response.data === undefined || response.data === null)
        throw new Error(message);
    return response.data;
}
//# sourceMappingURL=unwrapFormsResponse.js.map